import React from 'react';
import MetricCard from './MetricCard';
import { Monitor, TrendingUp, Users, FileVideo, Calendar, Receipt, Play, Layout } from 'lucide-react';
import { KPICard } from '../../types/dashboard.types';

const mockKpis: KPICard[] = [
  {
    title: 'MRR',
    value: 'R$ 0,00',
    icon: <TrendingUp className="w-6 h-6 text-green-600" />,
    status: 'neutral',
  },
  {
    title: 'ARR (Projetado)',
    value: 'R$ 0,00',
    icon: <Calendar className="w-6 h-6 text-blue-600" />,
    status: 'neutral',
  },
  {
    title: 'Ticket Médio',
    value: 'R$ 0,00',
    icon: <Receipt className="w-6 h-6 text-amber-600" />,
    status: 'neutral',
  },
  {
    title: 'Clientes Ativos',
    value: 0,
    icon: <Users className="w-6 h-6 text-blue-600" />,
    status: 'neutral',
  },
  {
    title: 'Dispositivos Online',
    value: '0/0',
    icon: <Monitor className="w-6 h-6 text-green-500" />,
    status: 'neutral',
  },
  {
    title: 'Total de Mídias',
    value: 0,
    icon: <FileVideo className="w-6 h-6 text-indigo-600" />,
    status: 'neutral',
  },
  {
    title: 'Mídias Ativas',
    value: 0,
    icon: <Play className="w-6 h-6 text-emerald-600" />,
    status: 'neutral',
  },
  {
    title: 'Telas Criadas',
    value: 0,
    icon: <Layout className="w-6 h-6 text-purple-600" />,
    status: 'neutral',
  },
];

interface KPISectionProps {
  loading?: boolean;
  data?: { kpis?: any[] };
}

// Função para mapear ícones baseado nos dados do hook
const mapIconToComponent = (iconName: string) => {
  switch (iconName) {
    case 'trending-up':
      return <TrendingUp className="w-6 h-6 text-green-600" />;
    case 'calendar':
      return <Calendar className="w-6 h-6 text-blue-600" />;
    case 'receipt':
      return <Receipt className="w-6 h-6 text-amber-600" />;
    case 'users':
      return <Users className="w-6 h-6 text-blue-600" />;
    case 'monitor':
      return <Monitor className="w-6 h-6 text-green-500" />;
    case 'file-video':
      return <FileVideo className="w-6 h-6 text-indigo-600" />;
    case 'play':
      return <Play className="w-6 h-6 text-emerald-600" />;
    case 'layout':
      return <Layout className="w-6 h-6 text-purple-600" />;
    default:
      return <Monitor className="w-6 h-6 text-gray-500" />;
  }
};

const KPISection: React.FC<KPISectionProps> = ({ loading, data }) => {
  // Mapear os dados do hook para o formato esperado pelo MetricCard
  const kpis = data?.kpis
    ? data.kpis.map(kpi => ({
      ...kpi,
      icon: mapIconToComponent(kpi.icon)
    }))
    : mockKpis;
  return (
    <section className="mb-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {loading
          ? Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="rounded-xl bg-gray-100 animate-pulse h-32" />
          ))
          : kpis.map((kpi, i) => <MetricCard key={i} {...kpi} />)}
      </div>
    </section>
  );
};

export default KPISection;